import { render } from "./NotifyManage.vue?vue&type=template&id=d6dc25b2&scoped=true"
import script from "./NotifyManage.vue?vue&type=script&lang=js"
export * from "./NotifyManage.vue?vue&type=script&lang=js"

import "./NotifyManage.vue?vue&type=style&index=0&id=d6dc25b2&lang=scss&scoped=true"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6dc25b2"]])

export default __exports__